/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { pluginPostbackHealthCheckRequestSchema } from "./pluginPostbackHealthCheckRequestSchema.ts";

export const callbackPluginHealthCheckCreateStatus200Schema = z.any();

export const callbackPluginHealthCheckCreateResponseSchema = callbackPluginHealthCheckCreateStatus200Schema;

export const callbackPluginHealthCheckCreateDataSchemaJson = pluginPostbackHealthCheckRequestSchema.describe(
	"Состояние устройств, присланное плагином по своей инициативе.",
);

export const callbackPluginHealthCheckCreateDataSchemaXml = pluginPostbackHealthCheckRequestSchema.describe(
	"Состояние устройств, присланное плагином по своей инициативе.",
);

export const callbackPluginHealthCheckCreateDataSchema = z.union([callbackPluginHealthCheckCreateDataSchemaJson, callbackPluginHealthCheckCreateDataSchemaXml]);
